
import { useDataURL, useData, useCoords } from './main'
import { defineComponent, ref, onMounted, computed} from 'vue';
import Widget from './components/Widget.vue';
import WidgetSettings from './components/WidgetSettings.vue';

export default defineComponent({
  name: 'App',

  components: {
    Widget,
    WidgetSettings
  },

  setup() {

    const { city, getCoords, BASE_URL, API_key, ls: lsCoords} = useCoords()
    const { getDataURL } = useDataURL()
    const { cities, getData, setUpdateData } = useData()

    const ls = window.localStorage
    const isCoords = ref(lsCoords.getItem("userCoord"))
    let widgetShow = ref(true)
    const addedCity = ref("")

    onMounted(() => {
      isCoords.value = lsCoords.getItem("userCoord")
      checkCoords()
    })

    const widgetVisibleToggler = () => widgetShow.value = !widgetShow.value

    const checkCoords = () => {
      // let coords = ls.getItem("userCoord")
      if (isCoords.value !== null) {
        city.value = isCoords.value
        getData(getDataURL(BASE_URL, isCoords.value, API_key))
      } else {
        getCoords()
        isCoords.value = lsCoords.getItem("userCoord")
      }
    }

    const updateData = (url:string) => fetch(url)
      .then(res => res.json())
      .then(res => setUpdateData(res, cities.value))
      .catch(error => console.error(error))

    const addCity = (e:string) => {
      if (!e) return
      updateData(getDataURL(BASE_URL, e, API_key))
    }

    const deleteCity = (id: number) => {
      cities.value = cities.value.filter((c) => c.id !== id)
      ls.setItem("wData", JSON.stringify(getCities.value))
    }

    const getCities = computed({
      get: () => cities.value,
      set: (val) => {
        cities.value = [...val]
        ls.setItem("wData", JSON.stringify(cities.value))
      }
    })

    const compCoords = computed({
      get: () => isCoords.value,
      set: (val) => isCoords.value = val
    })

    return {
      addCity,
      getCities,
      addedCity,
      compCoords,
      widgetShow,
      deleteCity,
      widgetVisibleToggler,
      ...useCoords(),
      ...useData()
    }
  },

});
